import { Component } from '@angular/core';

@Component({
  selector: 'svg-trash',
  standalone: true,
  imports: [],
  templateUrl: './trash.component.svg',
  styleUrl: './trash.component.scss',
})
export class TrashComponent {}
